export class AdditionalSubscriptionBuyingOpaque {
  additionalCardsCount: number;
  isMonthly: boolean;
  currentUserId?: bigint;

  constructor(additionalCardsCount: any, isMonthly: any, currentUserId?: bigint) {
    this.additionalCardsCount = Number(additionalCardsCount);
    this.isMonthly = Boolean(isMonthly);
    this.currentUserId = currentUserId;
  }
}
